import Vue from 'vue';
import Vuex from 'vuex';
import chat from './modules/chat';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    chat: {
      namespaced: true,
      state: chat.state,
      mutations: chat.mutations,
      getters: chat.getters,
    },
  },
});
